<template>
    <div class="main" v-loading.fullscreen="isLoad" element-loading-background="rgba(0, 0, 0,0)">
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item><div style="display: inline-block;" @click="gotopage('/Goods/index.html')">商品管理</div></el-breadcrumb-item>
            <el-breadcrumb-item>下架商品</el-breadcrumb-item>
        </el-breadcrumb>
        <el-form :inline="true" :model="item" class="search">
            <el-form-item label="名称/编码">
                <el-input v-model="item.name" placeholder="请输入商品名称或编码" size="small"></el-input>
            </el-form-item>

            <el-form-item label="商品分类">
                <el-cascader v-model="item.supplier_category_id" @change="changeCategory" placeholder="请选择"
                             :options="optionsProduct" :props="filterProps" clearable></el-cascader>
            </el-form-item>

            <el-form-item>
                <el-button type="primary" @click="submit" size="medium">查询</el-button>
            </el-form-item>
        </el-form>
		<div class="btns"> 
		    <el-button type="primary" size="small" @click="upper" v-auth="['supplier/product/upper']">批量上架</el-button>
		</div>
        <!--		:data="list"数据-->
        <el-table :data="list" border @selection-change="handleSelectionChange">
            <!--			这里 prop scope传值-->
            <el-table-column type="selection" align="center"></el-table-column>
            <!-- <el-table-column width="60" align="center">
                <template slot-scope="scope">
                    {{scope.$index + (page-1) * pageSize + 1}}
                </template>
            </el-table-column> -->
			<el-table-column prop="id" label="ID" width="80" align="center"></el-table-column>

            <el-table-column prop="name" label="名称"></el-table-column>
			<el-table-column label="商品编码">
				<template slot-scope="scope">
					{{scope.row.sku_no}}
				</template>
			</el-table-column>
            <el-table-column label="商品图片">
                <!--				商品的组件和插槽-->
                <template slot-scope="scope">
                    <div style="display: flex; align-items: center;">
                        <img :src="scope.row.product_pic_main" height="30" style="display: flex; margin-right: 5px;" />
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="category" label="商品分类">
                <template slot-scope="scope" v-if="scope.row.category">
                    {{scope.row.category.name}}
                </template>
            </el-table-column>
<!--            <el-table-column label="商品来源" align="center">-->
<!--                &lt;!&ndash;			价格模板插槽	&ndash;&gt;-->
<!--                <template slot-scope="scope">-->
<!--                    <div v-if="scope.row.in_store">-->
<!--                        自有商品-->
<!--                    </div>-->
<!--                    <div v-else>-->
<!--                        <div>供应商商品</div>-->
<!--                        <div style="margin-top: 10px">加价：<span style="color: red;">{{scope.row.price}}</span></div>-->
<!--                    </div>-->
<!--                </template>-->
<!--            </el-table-column>-->
            <el-table-column label="状态" align="center">
                <!--			价格模板插槽	-->
                <template slot-scope="scope">
                    <el-tag size="small" type="success" v-if="scope.row.is_marketable">
                        已上架
                    </el-tag>
                    <el-tag size="small" type="danger" v-else>
                        已下架
                    </el-tag>
                </template>
            </el-table-column>
            <el-table-column prop="created_date" label="添加时间" align="center"></el-table-column>
            <el-table-column prop="last_modified_date" label="更新时间" align="center"></el-table-column>
            <el-table-column label="操作" width="280">
                <template slot-scope="scope">
                    <!--					传ID过去修改-->
                    <el-button size="mini" type="primary" @click="edit(scope.row.id,scope.row.type)">查看
                    </el-button>
                    <el-popconfirm title="您确定要上架吗？" @confirm="putOn(scope.row.id,scope.row.type)"
                                   class="l10">
                        <el-button size="mini" type="warning" slot="reference">上架</el-button>
                    </el-popconfirm>
                </template>
            </el-table-column>
        </el-table>
        <!-- 价格 -->
		
        <!--		页码-->
        <el-pagination @size-change="sizeReload" @current-change="pageReload" :current-page="page"
                       :current-page.sync="pageNum" :page-sizes="[20, 100, 200, 300, 400]" :page-size="pageSize"
                       layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
    </div>
</template>
<script>
    export default {
        name: 'Menu',
        data() {
            return {
                // 商品数据
                list: [],
                isLoad: false,
                pageSize: 20,
                pageNum: 0,
                total: 0,
                page: 1,
                thumb: [],
                // 查询
                item: {},
                optionsShop: [],
                optionsProduct: [],
                dialogVisible: false,
                propId:'',
                propName: '',
                propPrice: '',
                price: '',
                multipleSelection:[],
                filterProps: {
                    value: 'id',
                    label: 'name',
                    emitPath: false,
                    checkStrictly: true
                },
            }
        },
        created() {
            this.item = {
                page: this.page,
                limit: this.pageSize,
                is_marketable: 0
            },
                this.getData()
            this.loadList()
        },
        methods: {
			gotopage(url){
			     var link =  this.$router.resolve({
			     path: url
			   });
			   window.open(link.href, '_blank')
			},
            getData() {
                // 获取商品分类
                this.axios.get('/supplier/data/getCategoryTreeSupplier', {}).then(res => {
                    this.optionsProduct = res.data.tree
                })
            },
            changeCategory(data) {
                let len = data.length;
                if (len == 0) {
                    // 清空数据
                    this.item.store_category_id = '';
                } else {
                    this.item.store_category_id = data[len - 1];
                }
            },
            // 获取数据
            loadList() {
                if (this.isLoad) {
                    return
                }
                this.isLoad = !this.isLoad
                //	将页码传到/Goods/index
                this.axios.post('/supplier/product/listOff', this.item)
                    .then(res => {
                        this.isLoad = !this.isLoad
                        // 后端返回的商品数据列表
                        this.list = res.data.list.data
                        this.total = res.data.list.total
                    })
                    .catch(() => {
                        this.isLoad = !this.isLoad
                    })
            },
            changePrice(row,id) {
                this.dialogVisible = true
                this.propName = row.name
                this.propPrice = row.price
                this.propId = id
            },
            handleClose(done) {
                this.dialogVisible = false
                this.price = ''
            },
            putOn(id) {
                this.isLoad = !this.isLoad
                this.axios.post('/supplier/product/putonORoff', {
                    id: id,
                    is_marketable: 1
                }).then(res => {
                    this.isLoad = !this.isLoad
                    this.$message.success({
                        message: '上架成功'
                    });
                    this.loadList()
                }).catch(() => {
                    this.isLoad = !this.isLoad
                })
            },
            handleSelectionChange(val) {
                this.multipleSelection = val;
            },
            // 带着商品ID跳转
            edit(productId, type) {
                // source区分来自店铺还是供应商
                let path = ''
                if (type == 1) {
                    path = '/Goods/edit.html'
                } else {
                    path = '/Goods/supplierEdit.html'
                }
                this.$router.push({
                    path: '/Goods/edit.html',
                    query: {
                        id: productId,
                        op: 2
                    }
                });
            },
            //sizeReload 共多少条为一页
            sizeReload(val) {
                this.pageSize = val
                this.item = {
                		page: this.page,
                		limit: this.pageSize,
                		is_marketable: false
                },
                this.getData()
                this.loadList()
            },
            // 前往第几页
            pageReload(val) {
                this.item.page = val
                this.loadList()
            },
            // 搜索查询
            submit() {
                this.pageNum = 1
                this.item.page = 1
                this.loadList()
            },
			//上架
			upper() {
			    let id = []
			    for (let key in this.multipleSelection) {
			        let item = this.multipleSelection[key]
			        id.push(item.id)
			    }
			    if (id.length == 0) {
			        this.$message.error({
			            message: '请选择商品',
			            showClose: false
			        });
			        return false;
			    }
			    if (this.isLoad) {
			        return false;
			    }
			    this.isLoad = !this.isLoad
			    this.axios.delete('/supplier/product/upper', {
			        data: {id: id, in_store: 0}
			    }).then(() => {
			        this.isLoad = false
			        this.$message.success({
			            message: '上架成功',
			            showClose: false
			        });
			        this.loadList()
			    })
			    .catch(() => {
			        this.isLoad = false
			    })
			},
            // 导出
            excelOut() {}
        }
    }
</script>
<style scoped>
</style>
